<div class="modal-wrapper">
	<div class="modal-header">
    <h1 class="modal-title" [innerHTML]="data.title"></h1>
	  <i class="ic-close icon-size-32" (click)="activeModal.dismiss('Cross click')"></i>
	</div>
	<div class="modal-body">
		<p class="description-modal" [innerHTML]="data.description"></p>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-dark" (click)="onDelete()">Cancel</button>
		<button class="btn btn-error" [innerHTML]="data.button" (click)="deleteItem()"></button>
	</div>
</div>
